import styled, { css } from "styled-components"

import { formatPriceByLocale } from "utils/utils"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function SelectOptionItem({
  index,
  no,
  stock,
  productTitle,
  optionName,
  decreaseDisable,
  increaseDisable,
  onOptionDelete,
  onQuantityDecrease,
  onQuantityIncrease,
  count,
  price, 
}) {
  return (
    <Block>
      <ItemTop>
        <ProductName>{productTitle}</ProductName> 
        <DeleteItemBtn onClick={() => onOptionDelete(index)}>
          <SVGIcon name="close" />
        </DeleteItemBtn>
      </ItemTop> 
      <ItemMiddle>
        <OptionName>{optionName}</OptionName>
      </ItemMiddle>
      <ItemBottom>
        <QuantityController>
          <DecreaseBtn onClick={() => onQuantityDecrease(no)} disabled={decreaseDisable}>
            -
          </DecreaseBtn>
          <OptionCount>{count}</OptionCount>
          <IncreaseBtn onClick={() => onQuantityIncrease(no, stock)} disabled={increaseDisable || (Number.isInteger(stock) && stock <= count)}>
            +
          </IncreaseBtn>
        </QuantityController>
        <OptionPrice>{`${formatPriceByLocale("ko", price)}원`}</OptionPrice>
      </ItemBottom>
    </Block>
  )
}

const Block = styled.li`
  background-color: #f7f7f7;
  border-radius: calc(100vw * (6 / 375));
  width: 100%;
  padding-top: calc(100vw * (10 / 375));
  padding-bottom: calc(100vw * (13 / 375));
  padding-right: calc(100vw * (16 / 375));
  padding-left: calc(100vw * (16 / 375));
  margin-bottom: calc(100vw * (10 / 375));
  &:last-child {
    margin-bottom: 0;
  }
`

const ItemTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(100vw * (7 / 375));
`

const ProductName = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (17 / 375));
  max-width: calc(100vw * (265 / 375));
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`
const ItemMiddle = styled.div` 
  margin-bottom: calc(100vw * (8 / 375));
`
const OptionName = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (14 / 375));
  max-width: calc(100vw * (265 / 375));
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden; 
  color: #7F7F7F;
`

const DeleteItemBtn = styled.button`
  width: calc(100vw * (10 / 375));
  height: calc(100vw * (10 / 375));

  svg {
    color: #4e4e4e;
  }
`

const ItemBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`

const QuantityController = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #c4c4c4;
  border-radius: calc(100vw * (6 / 375));
  background-color: #ffffff;
`

const buttonStyle = css`
  padding: calc(100vw * (8 / 375)) calc(100vw * (12 / 375));
  ${({ disabled }) =>
    disabled &&
    css`
      color: #c4c4c4;
    `}
`

const DecreaseBtn = styled.button`
  ${buttonStyle}
`

const IncreaseBtn = styled.button`
  ${buttonStyle}
`

const OptionCount = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  padding: calc(100vw * (9 / 375)) calc(100vw * (12 / 375));
`

const OptionPrice = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 700;
  line-height: calc(100vw * (19 / 375));
`
